import http from 'common-module/src/util/http';

export async function getList(params) {
  return http.post('/msg/list', params);
}
export async function getCategoryList(params, cfg) {
  return http.post('msg/category/list', params, cfg);
}
export async function setHasRead(params) {
  return http.post('/msg/mark-category-read', params);
}
export async function unreads(params) {
  return http.post('/msg/unreads', params);
}
export async function categoryUnreads(){
  return http.post('msg/category/unreads');
}
// 查询未完成的导入/导出列表
export async function queryUnfinishedImportOrExportList() {
  const result = await http.post('/issue-excel/query/import/list');
  return { result };
}

// 主动查询导入/导出结果
export async function queryImportOrExportResult(id) {
  return http.post('/issue-excel/query/import/result', id, {
    headers: {
      ['Content-Type']: 'application/json'
    }
  });
}

//导出评论结果
export async function queryImportIssueResult(id) {
  return http.post('/issue-excel/import/comment/result', id, {
    headers: {
      ['Content-Type']: 'application/json'
    }
  });
}

// 保存取用户系统消息是否显示的开关状态
export async function saveSysMessageSwitch(data) {
  const result = await http.post('/message-notify-config/save-sys-message-switch', data);
  return { result };
}

// 获取用户系统消息是否显示的开关状态
export async function getSysMessageSwitch() {
  const result = await http.post('/message-notify-config/sys-message-switch-status', {}, {
    headers: {
      ['Content-Type']: 'application/json'
    },
    showError: false
  });
  return { result };
}

// 查询用户消息通知的配置详情信息
export async function getMessageNotifyConfig() {
  const result = await http.post('/message-notify-config/query-message-notify-config', {
    headers: {
      ['Content-Type']: 'application/json'
    }
  });
  return { result };
}

// 保存取用户系统消息是否显示的开关状态
export async function saveMessageNotifyConfig(data) {
  const result = await http.post('/message-notify-config/save-message-notify-config', data);
  return { result };
}

// 获取所有im类型
export async function queryAllImType() {
  const result = await http.post('/im/app/query-all-im-type', {
    headers: {
      ['Content-Type']: 'application/json'
    }
  });
  return { result };
}


// 获取用户筛选记录
export async function closeBanner(data) {
  return http.post('/account/close-banner', data);
}

/**
 * 查询导入数据结果
 * @returns {Promise<*>}
 */
export const getOrgMemberImportResult = async (uuid) => {
  return http.get('/org-user/query-import-result', { uuid });
};

/**
 * 查询ldap导入结果
 * @returns {Promise<*>}
 */
export const getLDAPImportStatus = async (uuid) => {
  return http.get('/ldap/sync-status', { uuid });
};
